/** The draft is written on leaving each step, so its date says which step it reached. */
export const stopDraftResumePath = ({
  funnelBasePath,
  policyId,
  draft,
}: {
  funnelBasePath: string;
  policyId: string;
  draft?: { stopDate?: string; requiredDocuments?: string[] } | null;
}) => {
  if (!draft?.stopDate) {
    return `${funnelBasePath}/${policyId}/stop/date`;
  }

  // Nothing is written on leaving the documents step, so a reason needing proof always resumes
  // there — it is where the requester still has something to do.
  return `${funnelBasePath}/${policyId}/stop/${draft.requiredDocuments?.length ? 'documents' : 'recap'}`;
};
